var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cfixed",attrs:{"id":"cfixed"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.backBtn),expression:"backBtn"}],staticClass:"fixContainer",on:{"click":function($event){return _vm.backToTop()}}},[_c('i',{staticClass:"fa fa-angle-up",staticStyle:{"font-size":"40px"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-036d53c0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cfixed.vue
// module id = null
// module chunks = 